import { render, staticRenderFns } from "./ProductSettingsTabs.vue?vue&type=template&id=0bbb5db3&"
import script from "./ProductSettingsTabs.vue?vue&type=script&lang=js&"
export * from "./ProductSettingsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports